import React, { Fragment } from 'react';

import { Paper } from '@mui/material';

export function Content({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <Fragment>
      <Paper sx={{ p: 2 }}>{children}</Paper>
    </Fragment>
  );
}
